import { useMutation } from '@tanstack/react-query';

import { requestPinResetApi } from '../api';

export default function useRequestPinResetMutation(config?: any) {
  return useMutation(requestPinResetApi, config);
}
